import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-faq-metaobject-display.scss'
import {renderAccordions} from '@/scripts/modules/detail-accordion'


export default register(`section-faq-metaobject-display`, {
    onLoad() {
        renderAccordions(`section-faq-metaobject-display`, true)
    },
    onUnload() {

    },
})
